import { AlertTriangle, CheckCircle2, Clock3 } from 'lucide-react'
import { cn } from '@/shared/lib/utils'
import { toneSoftClass, type V2Tone } from './tone'

export type ServiceStatusBadgeTone = 'open' | 'pending' | 'closed' | 'neutral'

const toneMap: Record<ServiceStatusBadgeTone, V2Tone> = {
  open: 'ok',
  pending: 'warn',
  closed: 'err',
  neutral: 'neutral',
}

const toneIcon = {
  open: CheckCircle2,
  pending: Clock3,
  closed: AlertTriangle,
  neutral: Clock3,
}

export function ServiceStatusBadge({
  label,
  tone = 'neutral',
  className,
}: {
  label: string
  tone?: ServiceStatusBadgeTone
  className?: string
}) {
  const Icon = toneIcon[tone]

  return (
    <span
      className={cn(
        'inline-flex min-h-7 items-center gap-1.5 rounded-pill border px-2.5 text-xs font-medium',
        toneSoftClass[toneMap[tone]],
        className,
      )}
    >
      <Icon className="size-3.5 shrink-0" aria-hidden />
      <span className="truncate">{label}</span>
    </span>
  )
}
